import { Box, Button } from '@wix/design-system';
import t__default, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { CANCEL_BUTTON, SAVE_BUTTON } from './data-hooks.js';

const FooterActions = ({ onCancel, onSave }) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ t__default.createElement(Box, { align: "right", gap: "SP2" }, /* @__PURE__ */ t__default.createElement(Button, { onClick: onCancel, priority: "secondary", dataHook: CANCEL_BUTTON, size: "small" }, t("SettingsPanelFooter_Cancel")), /* @__PURE__ */ t__default.createElement(Button, { onClick: onSave, priority: "primary", dataHook: SAVE_BUTTON, size: "small" }, t("SettingsPanelFooter_Save")));
};

export { FooterActions };
//# sourceMappingURL=footer-actions.js.map
